import { Link, useSearchParams } from 'react-router-dom';
import { useDocumentTitle } from '../app/useDocumentTitle';
import { GuestOnly } from '../app/guards';
import { useT } from '../i18n/i18n';
import styles from './auth/AuthLayout.module.css';
import { EmailLinkForm } from './auth/EmailLinkForm';

export function LoginPage() {
  const t = useT();
  useDocumentTitle(t('nav.login'));
  const [params] = useSearchParams();
  const next = params.get('next');
  return (
    <GuestOnly>
      <EmailLinkForm
        withName={false}
        title={t('auth.loginTitle')}
        subtitle={t('auth.loginSubtitle')}
        submitLabel={t('auth.submitLogin')}
        footer={
          <p className={styles.switch}>
            {t('auth.noAccount')}{' '}
            <Link to={`/register${next ? `?next=${encodeURIComponent(next)}` : ''}`}>
              {t('auth.toRegister')}
            </Link>
          </p>
        }
      />
    </GuestOnly>
  );
}
